<template>
    <div> 
        <v-btn 
            class="rounded-lg ml-2" 
            text 
            outlined 
            color="#41916b"
            @click="$router.push(route)">
            {{ description }}
        </v-btn>
    </div>
</template>
<script>
export default {
  data() {
    return {
        description: this.$t('buttons.return_to_grid')
    }
  },

  props: {
    route: {
        type: String,
        default: "/pacientes",
    },
  },
}
</script>